import React from "react";
import ua from "../images/unauthorized_1.png";
// import decode from 'jwt-decode';
// import { AuthConsumer } from './AuthContext'

export default class Unauthorized extends React.Component {
  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <h2> It appears you don't have permission to access this page </h2>
        <br />
        <img src={ua} alt="Unauthorized" />
      </div>
    );
  }
}
